(function () {
  const state = { data: null };
  const money = (value) => value || "Not verified";
  const firstMatch = (value, pattern) => {
    const match = String(value || "").match(pattern);
    return match ? match[1] || match[0] : "";
  };
  const compactPrice = (value) => {
    const text = String(value || "").trim();
    const lower = text.toLowerCase();
    if (!text) return "Not verified";
    if (lower.includes("not publicly sold")) return "Not sold";
    if (lower.includes("enterprise quote") || lower.includes("contact sales")) return "Quote";
    if (lower.includes("no public msrp")) return "No MSRP";
    if (lower.includes("pricing not listed") || lower.includes("price not verified")) return "Not listed";
    const usdRange = text.match(/(?:USD\s*)?\$?\s*(\d[\d,]*(?:\.\d+)?(?:\s*-\s*\$?\s*\d[\d,]*(?:\.\d+)?)?)/i);
    if (usdRange) return `$${usdRange[1].replace(/\s+/g, "")}`;
    return text.split(/[;.]/)[0].trim() || "Not verified";
  };
  const compactMeasure = (value, unit) => {
    const text = String(value || "").trim();
    if (!text) return "Unknown";
    const escapedUnit = unit.replace("/", "\\/");
    const match = firstMatch(text, new RegExp(`(?:about\\s*|approx\\.?\\s*|~\\s*)?(\\d+(?:\\.\\d+)?\\s*${escapedUnit})`, "i"));
    return match ? match.replace(/\s+/g, " ") : text.split(/[;.]/)[0].trim();
  };
  const compactDof = (value) => {
    const text = String(value || "").trim();
    if (!text) return "Unknown";
    return firstMatch(text, /(\d+\+?)/) || "Unknown";
  };
  const compactRuntime = (value) => {
    const text = String(value || "").trim();
    if (!text) return "Unknown";
    const lower = text.toLowerCase();
    if (lower.includes("not publicly disclosed")) return "Not disclosed";
    const match = firstMatch(text, /(?:about\s*|approx\.?\s*|~\s*)?(\d+(?:\.\d+)?\s*(?:hours?|hrs?|h)\b)/i);
    return match ? match.replace(/\bh\b/i, "hr").replace(/\s+/g, " ") : text.split(/[;.]/)[0].trim();
  };
  const compactStatus = (value) => {
    const lower = String(value || "").toLowerCase();
    if (!lower) return "Review";
    if (lower.includes("discontinued")) return "Discontinued";
    if (lower.includes("available")) return "Available";
    if (lower.includes("pilot")) return "Piloting";
    if (lower.includes("prototype")) return "Prototype";
    if (lower.includes("announced")) return "Announced";
    if (lower.includes("development")) return "Development";
    return String(value || "Review").split(/[;.]/)[0].trim();
  };
  const compactComparisonValue = (robot, key) => {
    if (key === "price") return compactPrice(robot.price);
    if (key === "height") return compactMeasure(robot.height, "mm");
    if (key === "weight") return compactMeasure(robot.weight, "kg");
    if (key === "dof") return compactDof(robot.dof);
    if (key === "payload") return compactMeasure(robot.payload, "kg");
    if (key === "runtime") return compactRuntime(robot.runtime);
    if (key === "speed") return compactMeasure(robot.speed, "m/s");
    if (key === "status") return compactStatus(robot.status);
    return String(robot[key] || "Unknown").split(/[;.]/)[0].trim();
  };
  const safe = (value, fallback = "Not verified") => {
    const text = String(value || "").trim();
    return text ? text : fallback;
  };
  const escapeHtml = (value) => String(value || "").replace(/[&<>"']/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char]));
  const slugFromText = (value = "") => String(value || "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "") || "unknown";
  const robotMatchesSlug = (robot = {}, slug = "") => {
    const target = String(slug || "").trim();
    if (!target) return false;
    return robot.slug === target
      || slugFromText(robot.name) === target
      || slugFromText(`${robot.manufacturer || ""}-${robot.name || ""}`) === target
      || slugFromText(`${robot.manufacturer || ""} ${robot.name || ""}`) === target;
  };
  const robotUrl = (robot) => `/pages/robot-profile?robot=${encodeURIComponent(robot.slug)}`;
  const PAGE_META = {
    "robots": ["Robot Database", "Robots", "Search and filter source-backed robot profiles, prices, specifications, images, and videos."],
    "robot-profile": ["Robot Profile", "Robot Profile", "Robot reviews, specifications, pricing, images, videos, sources, and buying research from Firgelli Robots."],
    "manufacturers": ["Manufacturer Database", "Manufacturers", "Explore companies building humanoid, service, industrial, research, and mobile robots."],
    "manufacturer-profile": ["Manufacturer Profile", "Manufacturer Profile", "Source-backed manufacturer profiles connected to robot records."],
    "category": ["Robot Categories", "Robot Categories", "Browse robots by market, form factor, use case, and grade."],
    "compare": ["Comparison Engine", "Compare Robots", "Compare robots side by side using source-backed specification records."],
    "tools": ["Tools & Widgets", "Tools & Widgets", "Robot finder, matching tools, calculators, timelines, and future 3D viewer modules."],
    "research": ["Research Library", "Research, Patents & Sources", "Review papers, patents, manuals, videos, source URLs, and reference material."],
    "knowledge": ["Knowledge Hub", "Knowledge Hub", "Robot specifications, definitions, buying guidance, research links, and latest robotics updates."],
    "news": ["Robot News", "Robot News", "Latest robot additions, database changes, source-backed updates, and robotics research notes."],
    "marketplace": ["Marketplace", "Marketplace", "Future marketplace for robot accessories, skills, mods, and compatible parts."],
    "community": ["Community", "Community", "Future owner reviews, community posts, known issues, galleries, and mod discussions."],
    "developers": ["Developers", "Developers", "Developer resources, SDK support, APIs, ROS support, and integration tools."],
    "about": ["About", "About Firgelli Robots", "A research-first robotics intelligence platform for robot specifications, images, videos, and buyer guidance."],
    "editorial-policy": ["Editorial Policy", "Editorial Policy", "How Firgelli Robots reviews sources, image rights, robot specifications, and publication readiness."],
    "contact": ["Contact", "Contact Firgelli Robots", "Reach the Firgelli Robots team for research support, partnerships, and data corrections."]
  };
  const pathPageKind = () => {
    const match = location.pathname.match(/^\/pages\/([^/?#]+)/);
    return match && PAGE_META[match[1]] ? match[1] : "";
  };
  const resolvePageKind = (root) => {
    const configured = root.dataset.frPageKind || "auto";
    const fromPath = pathPageKind();
    if (configured === "auto") {
      return fromPath || "robots";
    }
    if (configured === "robots" && fromPath && fromPath !== "robots") {
      return fromPath;
    }
    if (configured === "robots" && root.querySelector(".fr-page-hero h1")?.textContent?.toLowerCase().includes("page not found")) {
      return fromPath || configured;
    }
    return configured;
  };
  const applyPageMeta = (root, kind) => {
    const meta = PAGE_META[kind];
    if (!meta) return;
    const [eyebrow, heading, subheading] = meta;
    const eyebrowNode = root.querySelector(".fr-page-hero .fr-eyebrow");
    const headingNode = root.querySelector(".fr-page-hero h1");
    const subheadingNode = root.querySelector(".fr-page-hero p:not(.fr-eyebrow)");
    const crumbNode = root.querySelector(".fr-breadcrumb span:last-child");
    if (eyebrowNode) eyebrowNode.textContent = eyebrow;
    if (headingNode) headingNode.textContent = heading;
    if (subheadingNode) subheadingNode.textContent = subheading;
    if (crumbNode) crumbNode.textContent = heading;
    document.title = `${heading} - Firgelli Robots`;
  };
  const badgeClass = (status) => {
    const s = String(status || "").toLowerCase();
    if (s.includes("prototype")) return "fr-badge fr-badge--prototype";
    if (s.includes("discontinued")) return "fr-badge fr-badge--discontinued";
    if (s.includes("announced") || s.includes("coming")) return "fr-badge fr-badge--announced";
    return "fr-badge";
  };
  const icon = () => `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v4"></path><path d="M6 8h12l-1 10H7L6 8Z"></path><path d="M9 12h.01"></path><path d="M15 12h.01"></path><path d="M9 21h6"></path><path d="M4 13H2"></path><path d="M22 13h-2"></path></svg>`;
  const categoryIcon = (slug = "") => {
    const icons = {
      humanoid: `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="4.5" r="2.1"></circle><path d="M12 7v6"></path><path d="M8.5 9.5 12 8l3.5 1.5"></path><path d="M10 13 8.5 20"></path><path d="M14 13l1.5 7"></path><path d="M9 20h2"></path><path d="M13 20h2"></path></svg>`,
      consumer: `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 11 12 4l8 7"></path><path d="M6.5 10.5V20h11V10.5"></path><path d="M9 20v-5h6v5"></path><path d="M10 11.5h4"></path></svg>`,
      enterprise: `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 20V5h9v15"></path><path d="M14 10h5v10"></path><path d="M8 8h2"></path><path d="M8 12h2"></path><path d="M8 16h2"></path><path d="M16.5 14h.01"></path><path d="M16.5 17h.01"></path></svg>`,
      industrial: `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20V9l5 3V9l5 3V8h6v12H4Z"></path><path d="M16 8V4h3v4"></path><path d="M7 16h2"></path><path d="M12 16h2"></path><path d="M17 16h1"></path></svg>`,
      warehouse: `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 10 12 5l8.5 5"></path><path d="M5 10v10h14V10"></path><path d="M8 14h8"></path><path d="M8 17h8"></path><path d="M9 20v-6h6v6"></path></svg>`,
      service: `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 14h12a4 4 0 0 1 4 4"></path><path d="M4 18h16"></path><path d="M7 14V9a3 3 0 0 1 6 0v5"></path><path d="M10 6V4"></path></svg>`,
      research: `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3v5l-5 9a3 3 0 0 0 2.6 4.5h8.8A3 3 0 0 0 19 17l-5-9V3"></path><path d="M9 3h6"></path><path d="M7 16h10"></path><path d="M9 19h6"></path></svg>`,
      military: `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 19 6v5c0 4.8-2.9 8.4-7 10-4.1-1.6-7-5.2-7-10V6l7-3Z"></path><path d="M12 8v7"></path><path d="M8.8 11.5h6.4"></path></svg>`
    };
    return icons[slug] || icon();
  };
  let assetBase = "";
  const homepageImageFallbacks = {
    "tesla-optimus": "https://www.firgellirobots.com/cdn/shop/t/16/assets/fr-home-compare-tesla-optimus-ad30d48fcf.png",
    "figure-ai-figure-02": "https://www.firgellirobots.com/cdn/shop/t/16/assets/fr-home-compare-figure-ai-figure-02-a475ade5a5.png",
    "unitree-robotics-unitree-g1": "https://www.firgellirobots.com/cdn/shop/t/16/assets/fr-home-compare-unitree-robotics-unitree-g1-726472fdcf.png",
    "apptronik-apollo": "https://www.firgellirobots.com/cdn/shop/t/16/assets/fr-home-compare-apptronik-apollo-1809635ecd.png",
    "agility-robotics-digit": "https://www.firgellirobots.com/cdn/shop/t/16/assets/fr-home-compare-agility-robotics-digit-ed6fa7c6f8.png",
    "1x-technologies-neo": "https://www.firgellirobots.com/cdn/shop/t/16/assets/fr-home-compare-1x-technologies-neo-7a03dc0fa4.png",
    "sanctuary-ai-phoenix": "https://www.firgellirobots.com/cdn/shop/t/16/assets/fr-home-compare-sanctuary-ai-phoenix-35d25960a8.png",
    "ubtech-robotics-walker-s": "https://www.firgellirobots.com/cdn/shop/t/16/assets/fr-home-compare-ubtech-robotics-walker-s-af89630df5.png",
    "fourier-intelligence-gr-2": "https://www.firgellirobots.com/cdn/shop/t/16/assets/fr-home-compare-fourier-intelligence-gr-2-f9187a0b9b.png",
    "unitree-robotics-unitree-h2": "https://www.firgellirobots.com/cdn/shop/t/16/assets/fr-home-compare-unitree-robotics-unitree-h2-7fde71e458.png"
  };
  const resolveImage = (src = "") => src.startsWith("asset://") ? `${assetBase}${src.replace("asset://", "")}` : src;
  const robotFallbackImage = (robot) => robot?.imageFallback || homepageImageFallbacks[robot?.slug] || "";
  const firstMediaImage = (items = []) => {
    if (!Array.isArray(items)) return "";
    const preferred = items.find((item) => item?.image && String(item.type || "").match(/hero|front|main|comparison|thumbnail|card|portrait/i));
    return preferred?.image || items.find((item) => item?.image)?.image || "";
  };
  const foundImageCandidates = (robot) => Array.isArray(robot?.foundImages)
    ? robot.foundImages.filter((item) => item?.image && (item.approved || item.officialImage || item.quality >= 80)).map((item) => item.image)
    : [];
  const imageCandidates = (robot) => {
    const candidates = [
      robot?.image,
      firstMediaImage(robot?.approvedMedia),
      firstMediaImage(robot?.imageViews),
      ...(Array.isArray(robot?.approvedMedia) ? robot.approvedMedia.map((item) => item.image) : []),
      ...(Array.isArray(robot?.imageViews) ? robot.imageViews.map((item) => item.image) : []),
      ...foundImageCandidates(robot),
      robotFallbackImage(robot),
    ].filter(Boolean).map(resolveImage);
    return [...new Set(candidates)];
  };
  const image = (robot, alt = "") => {
    const candidates = imageCandidates(robot);
    const src = candidates[0] || "";
    const fallbacks = candidates.slice(1);
    if (!src) return `<div class="fr-image-placeholder">${icon()}</div>`;
    return `<img loading="lazy" src="${escapeHtml(src)}" data-fr-fallbacks="${escapeHtml(JSON.stringify(fallbacks))}" alt="${escapeHtml(alt || robot.name)}">`;
  };
  document.addEventListener("error", (event) => {
    const img = event.target;
    if (!(img instanceof HTMLImageElement) || !img.dataset.frFallbacks) return;
    let fallbacks = [];
    try { fallbacks = JSON.parse(img.dataset.frFallbacks || "[]"); } catch (error) { fallbacks = []; }
    const next = fallbacks.shift();
    if (next) {
      img.dataset.frFallbacks = JSON.stringify(fallbacks);
      img.src = next;
    } else {
      img.replaceWith(document.createRange().createContextualFragment(`<div class="fr-image-placeholder">${icon()}</div>`));
    }
  }, true);
  const rawField = (robot, key) => robot?.rawFields?.[key] || "";
  const listFromText = (value = "", limit = 6) => String(value || "").split(/[;|]/).map((item) => item.trim()).filter(Boolean).slice(0, limit);
  const publicStatusLabel = (status = "") => {
    const text = String(status || "").toLowerCase();
    if (text.includes("known")) return "Verified";
    if (text.includes("calculated")) return "Calculated";
    if (text.includes("estimated")) return "Estimated";
    if (text.includes("n/a")) return "Not applicable";
    if (text.includes("need")) return "Source needed";
    return status || "Source needed";
  };
  const upsertMeta = (name, content) => {
    if (!content) return;
    let meta = document.querySelector(`meta[name="${name}"]`);
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", name);
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", content);
  };
  const mediaViewKey = (item = {}) => {
    const hay = `${item.displayLabel || ""} ${item.label || ""} ${item.type || ""} ${item.group || ""} ${item.sourcePath || ""}`.toLowerCase().replace(/[_-]+/g, " ");
    const checks = [
      ["contact_sheet", ["contact sheet"]],
      ["head_torso", ["head torso", "head close", "torso"]],
      ["arm_leg", ["arm leg"]],
      ["front", ["front", "portrait"]],
      ["side", ["side", "profile"]],
      ["rear", ["rear", "back"]],
      ["arm", ["arm", "hand"]],
      ["leg", ["leg", "feet", "foot"]],
      ["hero", ["hero", "main"]],
      ["square", ["square"]],
      ["landscape", ["landscape"]],
      ["mobile", ["mobile"]],
      ["social", ["social", "open graph"]],
      ["thumbnail", ["thumbnail", "thumb"]]
    ];
    for (const [key, tokens] of checks) {
      if (tokens.some((token) => hay.includes(token))) return key;
    }
    return `image:${item.image || item.sourcePath || item.label || ""}`;
  };
  const uniqueMedia = (items = [], limit = 80) => {
    const rows = Array.isArray(items) ? items.filter((item) => item && item.image) : [];
    const seenImages = new Set();
    const seenViews = new Set();
    const unique = [];
    rows.forEach((item) => {
      const imageKey = item.image || "";
      const viewKey = mediaViewKey(item);
      if (seenImages.has(imageKey) || seenViews.has(viewKey)) return;
      seenImages.add(imageKey);
      seenViews.add(viewKey);
      unique.push(item);
    });
    return unique.slice(0, limit);
  };
  function robotFaqs(robot) {
    const maker = robot.manufacturer || "the listed manufacturer";
    const price = safe(robot.price, "not publicly verified");
    const availability = safe(robot.status, "not publicly verified");
    const height = safe(robot.height, "not publicly listed");
    const runtime = safe(robot.runtime, "not publicly listed");
    const payload = safe(robot.payload, "not publicly listed");
    const sourceCount = Number((robot.sources || []).length + (robot.manuals || []).length + (robot.papers || []).length + (robot.communityMentions || []).length);
    return [
      [`What is ${robot.name}?`, `${robot.name} is a ${robot.category || "robot"} associated with ${maker}. Firgelli Robots tracks its public specifications, media, source links, availability status, and comparison data in one profile.`],
      [`Who makes ${robot.name}?`, `${robot.name} is listed with ${maker}. The manufacturer profile and source links on this page should be used to verify company-level details before making buying or research decisions.`],
      [`Is ${robot.name} available to buy?`, `Current availability status: ${availability}. If the robot is marked as a prototype, pilot, announced, or not publicly sold, treat pricing and delivery claims as preliminary.`],
      [`How much does ${robot.name} cost?`, `Pricing status: ${price}. Robot prices often vary by configuration, support contract, deployment type, and whether the buyer is a research, enterprise, or consumer customer.`],
      [`What are the main ${robot.name} specifications?`, `Known headline specs include height ${height}, runtime ${runtime}, payload ${payload}, and degrees of freedom ${safe(robot.dof, "not publicly listed")}. The full specification table below separates verified, estimated, and source-needed fields.`],
      [`What is ${robot.name} best used for?`, `${robot.name} is most useful to evaluate in the context of ${safe(robot.useCase || robot.targetMarket || robot.category, "robot research and comparison")}. Check the limitations section before assuming it is ready for home, factory, warehouse, or developer use.`],
      [`How reliable is the ${robot.name} data?`, `This profile currently links ${sourceCount.toLocaleString()} source records and marks unknown fields as unknown rather than filling gaps with guesses.`]
    ];
  }
  const setRobotSeo = (robot) => {
    const maker = robot.manufacturer || "Unknown manufacturer";
    const title = `${robot.name} Robot Review, Specs, Price & Images | Firgelli Robots`;
    const description = `${robot.name} by ${maker}: specifications, pricing status, images, videos, use cases, and source-linked robot data.`;
    const citationUrls = [...(robot.sources || []), ...(robot.manuals || []), ...(robot.papers || []), ...(robot.communityMentions || [])]
      .map((item) => item && item.url)
      .filter(Boolean)
      .slice(0, 12);
    document.title = title;
    upsertMeta("description", description.slice(0, 158));
    const faqs = robotFaqs(robot).slice(0, 8);
    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Product",
          "name": robot.name,
          "brand": maker,
          "manufacturer": { "@type": "Organization", "name": maker },
          "description": robot.summary || description,
          "image": robot.image ? resolveImage(robot.image) : undefined,
          "url": window.location.href,
          "additionalProperty": [
            ["Availability", robot.status],
            ["Price", robot.price],
            ["Height", robot.height],
            ["Weight", robot.weight],
            ["Payload", robot.payload],
            ["Runtime", robot.runtime],
            ["Degrees of freedom", robot.dof],
            ["Speed", robot.speed]
          ].filter(([, value]) => value).map(([name, value]) => ({ "@type": "PropertyValue", name, value }))
        },
        {
          "@type": "WebPage",
          "@id": window.location.href,
          "name": title,
          "description": description,
          "about": { "@type": "Product", "name": robot.name, "brand": maker },
          "citation": citationUrls
        },
        {
          "@type": "FAQPage",
          "mainEntity": faqs.map(([question, answer]) => ({
            "@type": "Question",
            "name": question,
            "acceptedAnswer": { "@type": "Answer", "text": answer }
          }))
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": `${location.origin}/` },
            { "@type": "ListItem", "position": 2, "name": "Robots", "item": `${location.origin}/pages/robots` },
            { "@type": "ListItem", "position": 3, "name": robot.name, "item": window.location.href }
          ]
        }
      ]
    };
    let script = document.querySelector("script[data-fr-robot-schema]");
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.frRobotSchema = "true";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);
  };
  const publicMediaLabel = (view = {}) => {
    const raw = String(view.displayLabel || view.label || view.type || "Robot image")
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    const lower = raw.toLowerCase();
    if (lower.includes("hero")) return "Main photo";
    if (lower.includes("rear/back")) return "Rear view";
    if (lower.includes("head/torso")) return "Head and torso";
    if (lower.includes("arm + leg")) return "Arm and leg detail";
    return raw || "Robot image";
  };
  const publicMediaGroup = (view = {}) => {
    const group = String(view.group || "").replace(/[_-]+/g, " ").trim();
    if (!group) return "";
    const lower = group.toLowerCase();
    if (lower.includes("approved") || lower.includes("generated")) return "standard view";
    return group;
  };
  const mediaGallery = (items = [], robot = {}, limit = 80) => {
    const media = uniqueMedia(items, limit);
    if (!media.length) return "";
    return `<div class="fr-view-gallery">${media.map((view) => `
      <article class="fr-view-card">
        <img loading="lazy" src="${escapeHtml(resolveImage(view.image || ""))}" alt="${escapeHtml(`${robot.name || "Robot"} ${publicMediaLabel(view)}`)}">
        <strong>${escapeHtml(publicMediaLabel(view))}</strong>
        <span>${escapeHtml([publicMediaGroup(view), view.officialImage ? "manufacturer source" : ""].filter(Boolean).join(" - "))}</span>
      </article>
    `).join("")}</div>`;
  };
  const viewGallery = (robot) => mediaGallery(Array.isArray(robot.imageViews) ? robot.imageViews : [], robot, 12);
  const statusClass = (status = "") => `fr-status fr-status--${String(status || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
  const isDisplayableSpecRow = (row = {}) => {
    const value = String(row.value || "").trim().toLowerCase();
    const status = String(row.status || "").trim().toLowerCase();
    if (!value || value === "not found yet" || value === "not publicly listed") return false;
    if (status.includes("need") || status.includes("research")) return false;
    return true;
  };
  const publicSpecValue = (value = "") => {
    const raw = String(value || "").trim();
    const lower = raw.toLowerCase();
    if (lower === "true") return "Yes";
    if (lower === "false") return "No";
    if (lower === "n/a") return "Not applicable";
    return raw;
  };
  const renderSpecSections = (robot) => {
    const hiddenCategories = new Set(["Internal Database Fields", "Website Assets", "SEO / Knowledge Graph"]);
    const sections = (Array.isArray(robot.specSections) ? robot.specSections : [])
      .filter((section) => !hiddenCategories.has(section.category))
      .map((section) => ({ ...section, rows: (section.rows || []).filter(isDisplayableSpecRow) }))
      .filter((section) => section.rows.length);
    if (!sections.length) return "";
    return `<div class="fr-spec-chart">${sections.map((section, index) => `
      <details class="fr-spec-section" ${index < 8 ? "open" : ""}>
        <summary><span>${escapeHtml(section.category)}</span><em>${Number(section.rows.length || 0).toLocaleString()} documented fields</em></summary>
        <div class="fr-spec-table">
          ${section.rows.map((row) => `
            <div class="fr-spec-row">
              <span>${escapeHtml(row.label)}</span>
              <strong>${escapeHtml(publicSpecValue(row.value))}</strong>
              <em class="${statusClass(row.status)}">${escapeHtml(publicStatusLabel(row.status))}</em>
            </div>
          `).join("")}
        </div>
      </details>
    `).join("")}</div>`;
  };
  const sourceTypeLabel = (value = "") => {
    const key = String(value || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
    const labels = {
      official_product_page: "Official product page",
      manufacturer_page: "Manufacturer page",
      official_press_release: "Official press release",
      press_release: "Press release",
      manual: "Manual",
      user_manual: "User manual",
      technical_manual: "Technical manual",
      quick_start_guide: "Quick start guide",
      api_docs: "API documentation",
      sdk_docs: "SDK documentation",
      white_paper: "White paper",
      research_paper: "Research paper",
      paper: "Research paper",
      patent: "Patent",
      news: "News coverage",
      review: "Review",
      forum: "Forum discussion",
      owner_review: "Owner review"
    };
    if (labels[key]) return labels[key];
    return String(value || "Reference source").replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim().replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const sourceHost = (item = {}) => {
    if (item.domain || item.publisher) return String(item.domain || item.publisher).replace(/^www\./, "");
    try {
      return new URL(item.url, window.location.href).hostname.replace(/^www\./, "");
    } catch (error) {
      return "";
    }
  };
  const sourcePathLabel = (url = "") => {
    try {
      const parsed = new URL(url, window.location.href);
      const path = parsed.pathname.split("/").filter(Boolean).slice(0, 2).join(" / ");
      return path ? `${path} page` : "";
    } catch (error) {
      return "";
    }
  };
  const sourceTitle = (item = {}, robot = {}) => {
    const raw = String(item.title || "").trim();
    const kind = sourceTypeLabel(item.type);
    if (raw && raw !== item.url) {
      const lower = raw.toLowerCase();
      const kindLower = kind.toLowerCase();
      if (!lower.includes(kindLower) && ["Official product page", "Manufacturer page", "Manual", "Patent", "Research paper"].includes(kind)) {
        return `${raw} ${kind.toLowerCase()}`;
      }
      return raw;
    }
    const host = sourceHost(item);
    return `${robot.name || "Robot"} ${kind.toLowerCase()}${host ? ` from ${host}` : ""}`;
  };
  const uniqueSourceRows = (items = []) => {
    const rows = Array.isArray(items) ? items.filter((item) => item && item.url) : [];
    const seen = new Set();
    return rows.filter((item) => {
      const key = String(item.url || "").trim().toLowerCase().replace(/\/+$/, "");
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    }).slice(0, 16);
  };
  const listPhrase = (items = []) => {
    const values = items.filter(Boolean);
    if (!values.length) return "";
    if (values.length === 1) return values[0];
    if (values.length === 2) return `${values[0]} and ${values[1]}`;
    return `${values.slice(0, -1).join(", ")}, and ${values[values.length - 1]}`;
  };
  const linkCards = (items = [], robot = {}) => {
    const rows = uniqueSourceRows(items);
    if (!rows.length) return "";
    return `<div class="fr-source-grid">${rows.map((item) => {
      const host = sourceHost(item);
      const type = sourceTypeLabel(item.type);
      const path = sourcePathLabel(item.url);
      const meta = [type, host, path].filter(Boolean).join(" - ");
      const summary = String(item.summary || "").trim();
      return `
        <article class="fr-source-card">
          <a href="${escapeHtml(item.url)}" target="_blank" rel="noopener noreferrer">
            <strong>${escapeHtml(sourceTitle(item, robot))}</strong>
            <span>${escapeHtml(meta || "Reference source")}</span>
            ${summary && !/fetch failed/i.test(summary) ? `<em>${escapeHtml(summary.slice(0, 170))}</em>` : ""}
            <b>Open source</b>
          </a>
        </article>`;
    }).join("")}</div>`;
  };
  const robotSourcesPanel = (robot) => {
    const buckets = [
      ["Official and primary sources", "Manufacturer pages, launch pages, and other primary references used to verify the public robot profile.", robot.sources],
      ["Manuals and technical documentation", "Manuals, developer documentation, quick-start guides, SDK notes, and technical PDFs where available.", robot.manuals],
      ["Research papers and patents", "Academic papers, patents, white papers, and technical research connected to the robot or platform.", robot.papers],
      ["Community and owner notes", "Public owner notes, forum posts, reviews, and community references with usable links.", robot.communityMentions]
    ].map(([title, description, items]) => ({ title, description, rows: uniqueSourceRows(items) })).filter((bucket) => bucket.rows.length);
    if (!buckets.length) {
      return `<div class="fr-source-empty"><strong>Sources are being verified for ${escapeHtml(robot.name || "this robot")}.</strong><p>Firgelli Robots only publishes usable citation links in this section, so queued research placeholders and unverified backlog records are kept out of the customer-facing page.</p></div>`;
    }
    const total = buckets.reduce((sum, bucket) => sum + bucket.rows.length, 0);
    const domains = [...new Set(buckets.flatMap((bucket) => bucket.rows.map(sourceHost).filter(Boolean)))].slice(0, 6);
    const sourceKinds = buckets.map((bucket) => bucket.title.toLowerCase());
    const category = robot.category || "robot";
    return `
      <div class="fr-source-summary">
        <div>
          <strong>${Number(total).toLocaleString()} verified ${total === 1 ? "reference" : "references"} for ${escapeHtml(robot.name || "this robot")}</strong>
          <p>This ${escapeHtml(category)} profile connects ${escapeHtml(listPhrase(sourceKinds))} to help verify specifications, price status, availability, images, videos, developer support, and comparison notes before deeper research or buying decisions.</p>
        </div>
        ${domains.length ? `<div class="fr-source-domain-row" aria-label="Source domains">${domains.map((domain) => `<span>${escapeHtml(domain)}</span>`).join("")}</div>` : ""}
      </div>
      <div class="fr-robot-source-layout">
        ${buckets.map((bucket) => `
          <section class="fr-source-group">
            <h3>${escapeHtml(bucket.title)}</h3>
            <p>${escapeHtml(bucket.description)}</p>
            ${linkCards(bucket.rows, robot)}
          </section>
        `).join("")}
      </div>`;
  };
  const videoEmbedUrl = (url = "") => {
    try {
      const parsed = new URL(url, window.location.href);
      const host = parsed.hostname.replace(/^www\./, "").toLowerCase();
      if (host === "youtube.com" || host === "m.youtube.com") {
        const watchId = parsed.searchParams.get("v");
        const shortsId = parsed.pathname.match(/\/shorts\/([^/?#]+)/)?.[1];
        const embedId = parsed.pathname.match(/\/embed\/([^/?#]+)/)?.[1];
        const id = watchId || shortsId || embedId;
        if (id) return `https://www.youtube.com/embed/${encodeURIComponent(id)}`;
      }
      if (host === "youtu.be") {
        const id = parsed.pathname.split("/").filter(Boolean)[0];
        if (id) return `https://www.youtube.com/embed/${encodeURIComponent(id)}`;
      }
      if (host === "vimeo.com" || host === "player.vimeo.com") {
        const id = parsed.pathname.split("/").filter(Boolean).pop();
        if (id && id !== "video") return `https://player.vimeo.com/video/${encodeURIComponent(id)}`;
      }
      return parsed.href;
    } catch (error) {
      return url;
    }
  };
  const isDirectVideoUrl = (url = "") => /\.(mp4|webm|ogg)(?:$|[?#])/i.test(String(url));
  const videoFrame = (url, title, robotName) => {
    const embedUrl = videoEmbedUrl(url);
    const frameTitle = `${robotName || "Robot"} ${title || "movement video"}`;
    if (isDirectVideoUrl(embedUrl)) {
      const srcdoc = `<!doctype html><html><head><meta name="viewport" content="width=device-width,initial-scale=1"><style>html,body{margin:0;height:100%;background:#071525}video{display:block;width:100%;height:100%;object-fit:contain;background:#071525}</style></head><body><video controls preload="metadata" src="${escapeHtml(embedUrl)}"></video></body></html>`;
      return `<iframe class="fr-video-frame" srcdoc="${escapeHtml(srcdoc)}" title="${escapeHtml(frameTitle)}" loading="lazy" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    }
    return `<iframe class="fr-video-frame" src="${escapeHtml(embedUrl)}" title="${escapeHtml(frameTitle)}" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
  };
  const videoIframes = (robot) => {
    const videos = Array.isArray(robot.videos) ? robot.videos : [];
    if (!videos.length) return `<p class="fr-muted">No movement videos are linked yet.</p>`;
    return `<div class="fr-video-grid">${videos.map((item, index) => {
      const record = typeof item === "string" ? { url: item } : item;
      const url = record.url || "";
      const title = record.title || record.type || `Robot movement video ${index + 1}`;
      return `
        <article class="fr-video-card">
          ${videoFrame(url, title, robot.name)}
          <div>
            <strong>${escapeHtml(title)}</strong>
            <span>${escapeHtml([record.platform, record.type].filter(Boolean).join(" - ") || "Video evidence")}</span>
            ${record.source ? `<a href="${escapeHtml(record.source)}">Source -></a>` : ""}
          </div>
        </article>`;
    }).join("")}</div>`;
  };
  const bindTabs = (root = document) => {
    root.querySelectorAll("[data-fr-tabs]").forEach((tabs) => {
      const buttons = Array.from(tabs.querySelectorAll("[data-fr-tab-button]"));
      const panels = Array.from(tabs.querySelectorAll("[data-fr-tab-panel]"));
      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          const selected = button.dataset.frTabButton;
          buttons.forEach((item) => item.classList.toggle("is-active", item === button));
          panels.forEach((panel) => {
            const active = panel.dataset.frTabPanel === selected;
            panel.classList.toggle("is-active", active);
            panel.hidden = !active;
          });
        });
      });
    });
  };
  const approvedMedia = (robot) => Array.isArray(robot.approvedMedia) && robot.approvedMedia.length ? robot.approvedMedia : (Array.isArray(robot.imageViews) ? robot.imageViews : []);
  const mediaMatches = (item, tokens) => {
    const hay = `${item.label || ""} ${item.type || ""} ${item.group || ""} ${item.sourcePath || ""}`.toLowerCase().replace(/[_-]+/g, " ");
    return tokens.some((token) => hay.includes(token));
  };
  const pickMediaSet = (robot, definitions, limit = 8) => {
    const media = uniqueMedia(approvedMedia(robot), 64);
    const used = new Set();
    const selected = [];
    definitions.forEach(([label, tokens]) => {
      const match = media.find((item) => !used.has(item.image) && mediaMatches(item, tokens));
      if (match) {
        used.add(match.image);
        selected.push({ ...match, displayLabel: label });
      }
    });
    media.forEach((item) => {
      if (selected.length < limit && !used.has(item.image)) {
        used.add(item.image);
        selected.push(item);
      }
    });
    return selected.slice(0, limit);
  };
  const mediaTileGrid = (items, robot, modifier = "") => {
    const media = Array.isArray(items) ? items : [];
    if (!media.length) return `<p class="fr-muted">No image gallery is available yet.</p>`;
    return `<div class="fr-angle-grid ${modifier}">${media.map((view) => `
      <article class="fr-angle-tile">
        <img loading="lazy" src="${escapeHtml(resolveImage(view.image || ""))}" alt="${escapeHtml(`${robot.name || "Robot"} ${publicMediaLabel(view)}`)}">
        <strong>${escapeHtml(publicMediaLabel(view))}</strong>
      </article>
    `).join("")}</div>`;
  };
  const specLookup = (robot, labels) => {
    const wanted = labels.map((label) => label.toLowerCase());
    for (const section of robot.specSections || []) {
      for (const row of section.rows || []) {
        if (wanted.includes(String(row.label || "").toLowerCase())) return row.value || "";
      }
    }
    return "";
  };
  const shortValue = (value) => {
    const text = safe(value, "Not verified");
    return text.length > 84 ? `${text.slice(0, 82).trim()}...` : text;
  };
  const robotChecklist = (robot) => {
    const mediaCount = approvedMedia(robot).length;
    const checks = [
      ["Image gallery", mediaCount ? `${mediaCount} images` : "Not listed yet"],
      ["Main robot photo", robot.image ? "Available" : "Not listed yet"],
      ["Specification fields", `${Number(robot.specSummary?.Total || 0).toLocaleString()} fields`],
      ["Source links", `${Number((robot.sources || []).length).toLocaleString()} sources`],
      ["Media library", `${mediaCount.toLocaleString()} images`],
      ["Profile depth", robot.completeness >= 80 ? "Strong" : "Still growing"],
    ];
    return `<ul class="fr-dossier-checklist">${checks.map(([label, value]) => `<li><span></span><strong>${escapeHtml(label)}</strong><em>${escapeHtml(value)}</em></li>`).join("")}</ul>`;
  };
  const pipelineSteps = (robot) => {
    const steps = [
      ["1", "Identity", robot.id ? "Listed" : "Not listed"],
      ["2", "Images", approvedMedia(robot).length ? "Available" : "Needed"],
      ["3", "Specs", `${Number(robot.specSummary?.Known || 0).toLocaleString()} known`],
      ["4", "Sources", `${Number((robot.sources || []).length).toLocaleString()} sources`],
      ["5", "Docs", `${Number((robot.manuals || []).length + (robot.papers || []).length).toLocaleString()} linked`],
      ["6", "Profile", "Published"],
    ];
    return `<div class="fr-dossier-pipeline">${steps.map((step, index) => `
      <div class="fr-pipeline-step">
        <span>${escapeHtml(step[0])}</span>
        <strong>${escapeHtml(step[1])}</strong>
        <em>${escapeHtml(step[2])}</em>
      </div>
      ${index < steps.length - 1 ? `<b>-></b>` : ""}
    `).join("")}</div>`;
  };
  const knownSpecRows = (robot, categories = [], limit = 8) => {
    const wanted = categories.map((category) => category.toLowerCase());
    const rows = [];
    (robot.specSections || []).forEach((section) => {
      if (wanted.length && !wanted.some((name) => String(section.category || "").toLowerCase().includes(name))) return;
      (section.rows || []).forEach((row) => {
        if (isDisplayableSpecRow(row)) rows.push(row);
      });
    });
    return rows.slice(0, limit);
  };
  const specSentence = (robot, categories, fallback) => {
    const rows = knownSpecRows(robot, categories, 4);
    if (!rows.length) return fallback;
    return rows.map((row) => `${row.label}: ${row.value}`).join("; ");
  };
  const internalLinkList = (items = []) => `<div class="fr-related-links">${items.filter(Boolean).map((item) => `<a href="${escapeHtml(item.url)}">${escapeHtml(item.label)}</a>`).join("")}</div>`;
  const relatedRobots = (robot, data, limit = 6) => {
    const seen = new Set([robot.slug]);
    const rows = [];
    const add = (candidate) => {
      if (!candidate || seen.has(candidate.slug)) return;
      rows.push(candidate);
      seen.add(candidate.slug);
    };
    data.robots.filter((item) => item.manufacturer && item.manufacturer === robot.manufacturer).forEach(add);
    data.robots.filter((item) => item.category && item.category === robot.category).forEach(add);
    (data.featuredRobots || []).forEach(add);
    return rows.slice(0, limit);
  };
  const faqBlock = (faqs = []) => `<div class="fr-faq-list">${faqs.map(([question, answer]) => `
    <details class="fr-faq-item">
      <summary>${escapeHtml(question)}</summary>
      <p>${escapeHtml(answer)}</p>
    </details>
  `).join("")}</div>`;
  const robotSeoArticle = (robot, data) => {
    const maker = robot.manufacturer || "Unknown manufacturer";
    const related = relatedRobots(robot, data, 6);
    const mediaCount = approvedMedia(robot).length;
    const sourceCount = Number((robot.sources || []).length + (robot.manuals || []).length + (robot.papers || []).length);
    const targetMarket = safe(robot.targetMarket || robot.useCase || rawField(robot, "target_market"), "robot buyers, researchers, engineers, and comparison shoppers");
    const hardware = specSentence(robot, ["physical", "degrees", "hands", "payload"], `Public hardware details are still incomplete for ${robot.name}; known dimensions and manipulation fields are listed in the specification table.`);
    const mobility = specSentence(robot, ["mobility", "performance"], `${robot.name} should be evaluated from the public mobility fields below, especially walking method, speed, terrain limits, and stability notes where available.`);
    const battery = specSentence(robot, ["battery"], `Battery chemistry, charging method, and runtime are not fully documented in the public data yet. Runtime should not be assumed beyond the fields shown in the specification table.`);
    const aiSoftware = specSentence(robot, ["software", "ai", "developer"], `Software, SDK, ROS, local AI, and cloud AI details are tracked when publicly available. Unknown software fields stay marked as not listed until a stronger source is connected.`);
    const hands = specSentence(robot, ["hands", "payload"], `End-effector and hand details are not fully documented yet. Use payload, hand DOF, finger count, and grip fields when comparing manipulation ability.`);
    const strengths = [
      sourceCount ? `${sourceCount.toLocaleString()} linked source records support verification.` : "",
      mediaCount ? `${mediaCount.toLocaleString()} approved image assets help compare visible design and proportions.` : "",
      robot.height ? `Height is listed as ${robot.height}.` : "",
      robot.payload ? `Payload is listed as ${robot.payload}.` : "",
      robot.dof ? `Degrees of freedom are listed as ${robot.dof}.` : ""
    ].filter(Boolean);
    const limitations = [
      !robot.price || /not verified|not publicly|quote|listed/i.test(robot.price) ? "Pricing should be treated as unconfirmed or configuration-dependent." : "",
      /prototype|pilot|announced|development|not publicly/i.test(String(robot.status || "")) ? "Availability may be limited to pilots, announcements, or non-public deployment." : "",
      !robot.runtime ? "Runtime is not fully documented in the public data." : "",
      !robot.source ? "A primary source URL is not yet attached to this profile." : "",
      "Robot specifications can change quickly as manufacturers revise hardware, software, and deployment programs."
    ].filter(Boolean);
    const relatedLinks = [
      robot.manufacturer ? { label: `${maker} manufacturer profile`, url: `/pages/manufacturer-profile?manufacturer=${encodeURIComponent(slugifyLocal(maker))}` } : null,
      { label: `${robot.category || "Robot"} category`, url: `/pages/category?filter=${encodeURIComponent(robot.category || "humanoid")}` },
      { label: "Robot comparison tool", url: `/pages/compare?add=${encodeURIComponent(robot.slug)}` },
      { label: "Robot price guide", url: "/pages/knowledge?topic=Price" },
      { label: "Robot DOF explained", url: "/pages/knowledge?topic=DOF" },
      { label: "Robot battery runtime explained", url: "/pages/knowledge?topic=Runtime" }
    ];
    return `
      <section class="fr-seo-article fr-robot-panel">
        <p class="fr-eyebrow">${escapeHtml(robot.name)} Review</p>
        <h2>${escapeHtml(robot.name)} review, specs, price, availability and comparison</h2>
        <p><strong>Quick answer:</strong> ${escapeHtml(robot.name)} is a ${escapeHtml(robot.category || "robot")} associated with ${escapeHtml(maker)}. Based on currently available public information, its availability is ${escapeHtml(safe(robot.status, "not publicly confirmed"))}, and its pricing status is ${escapeHtml(safe(robot.price, "not publicly confirmed"))}.</p>
        <p>This profile is designed for people comparing humanoid robots, evaluating robot buying options, checking developer suitability, or researching the state of commercial robotics. Unknown fields stay unknown until a stronger source is attached.</p>

        <div class="fr-seo-grid">
          <article><h3>What is ${escapeHtml(robot.name)}?</h3><p>${escapeHtml(robot.summary || `${robot.name} is tracked as a ${robot.category || "robot"} in the Firgelli Robots Knowledge Brain. The profile combines public specifications, manufacturer references, approved images, and source links.`)}</p></article>
          <article><h3>Who makes it?</h3><p>${escapeHtml(maker)} is the manufacturer currently connected to this profile. Use the linked manufacturer page and source cards below to verify company-level details, model lineage, and official product information.</p></article>
          <article><h3>What is it designed for?</h3><p>${escapeHtml(robot.name)} is most relevant for ${escapeHtml(targetMarket)}. Treat use-case claims carefully when the robot is still marked as prototype, piloting, announced, or unavailable to the public.</p></article>
          <article><h3>Availability and price</h3><p>Availability: ${escapeHtml(safe(robot.status, "not publicly listed"))}. Price: ${escapeHtml(safe(robot.price, "not publicly listed"))}. Robot pricing often depends on configuration, support contract, accessories, and whether the customer is buying, leasing, or joining a pilot.</p></article>
        </div>

        <h3>Hardware and design</h3>
        <p>${escapeHtml(hardware)}</p>
        <h3>Mobility</h3>
        <p>${escapeHtml(mobility)}</p>
        <h3>Hands, manipulation and payload</h3>
        <p>${escapeHtml(hands)}</p>
        <h3>Battery and charging</h3>
        <p>${escapeHtml(battery)}</p>
        <h3>AI, software and developer support</h3>
        <p>${escapeHtml(aiSoftware)}</p>

        <div class="fr-seo-grid">
          <article><h3>Strengths</h3><ul>${(strengths.length ? strengths : ["This profile is connected to the broader Firgelli Robots comparison database."]).map((item) => `<li>${escapeHtml(item)}</li>`).join("")}</ul></article>
          <article><h3>Limitations and uncertainties</h3><ul>${limitations.map((item) => `<li>${escapeHtml(item)}</li>`).join("")}</ul></article>
          <article><h3>Best use cases</h3><ul>${listFromText(robot.useCase || robot.targetMarket || "Research; Comparison shopping; Robotics education; Enterprise evaluation", 6).map((item) => `<li>${escapeHtml(item)}</li>`).join("")}</ul></article>
          <article><h3>Not ideal for</h3><ul><li>Buyers who need guaranteed availability without confirming directly with the manufacturer.</li><li>Procurement decisions that require independently verified pricing, warranty, and deployment support.</li><li>Applications where missing safety, runtime, payload, or autonomy data cannot be tolerated.</li></ul></article>
        </div>

        <h3>Similar robots and comparisons</h3>
        <p>Compare ${escapeHtml(robot.name)} against nearby robots to understand maturity, cost, availability, hardware tradeoffs, and ecosystem differences.</p>
        ${internalLinkList(related.map((item) => ({ label: item.name, url: robotUrl(item) })).concat(relatedLinks))}

        <h3>FAQ</h3>
        ${faqBlock(robotFaqs(robot))}
      </section>`;
  };
  const slugifyLocal = (value = "") => String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  const categorySeoContent = (kind, data, robots) => {
    const category = new URLSearchParams(location.search).get("filter") || "humanoid";
    const record = (data.categories || []).find((item) => item.slug === category) || { label: "Robot Database", description: "Robots tracked in the Firgelli Robots Knowledge Brain." };
    const top = robots.slice(0, 8);
    return `
      <section class="fr-seo-article fr-card fr-section">
        <p class="fr-eyebrow">Category Guide</p>
        <h2>${escapeHtml(record.label)} guide, best robots and buying considerations</h2>
        <p>${escapeHtml(record.description || `${record.label} are tracked by use case, availability, specifications, images, and source quality.`)}</p>
        <div class="fr-seo-grid">
          <article><h3>What belongs in this category?</h3><p>Robots are included when their public records match this category flag or their primary category. The filter uses Knowledge Brain fields, not advertising language alone.</p></article>
          <article><h3>What does not belong?</h3><p>Robots without enough matching evidence, unrelated automation products, or records with uncertain category mapping should remain outside this landing page until reviewed.</p></article>
          <article><h3>What to compare</h3><p>Start with availability, price, height, payload, runtime, mobility, DOF, developer support, source count, and whether the robot has approved images or public videos.</p></article>
          <article><h3>Limitations</h3><p>Many robot manufacturers publish partial information. Missing price, runtime, SDK, safety, and deployment data should be treated as a research gap, not as a hidden positive.</p></article>
        </div>
        <h3>Best robots in this category</h3>
        ${internalLinkList(top.map((robot) => ({ label: robot.name, url: robotUrl(robot) })))}
        <h3>FAQ</h3>
        ${faqBlock([
          [`What is the best ${record.label.toLowerCase()}?`, `The best choice depends on whether you need consumer access, enterprise deployment, developer support, payload, runtime, or research flexibility. Use the comparison table and robot detail pages rather than relying on one headline spec.`],
          [`Are ${record.label.toLowerCase()} for sale?`, `Some are sold, some are enterprise-only, and many are still prototypes or pilot programs. Always verify the current availability status on the robot profile and manufacturer source.`],
          [`Which specs matter most?`, `Price, availability, payload, runtime, DOF, safety, SDK/ROS support, and source quality usually matter more than promotional videos alone.`]
        ])}
      </section>`;
  };
  const manufacturerSeoContent = (manufacturer, robots) => {
    const lineup = robots.filter((robot) => robot.manufacturer === manufacturer.name).slice(0, 12);
    return `
      <section class="fr-seo-article fr-card fr-section">
        <p class="fr-eyebrow">Manufacturer Profile</p>
        <h2>${escapeHtml(manufacturer.name)} robots, company focus and public lineup</h2>
        <p>${escapeHtml(manufacturer.name)} is listed in the Firgelli Robots manufacturer database with a focus on ${escapeHtml(safe(manufacturer.focus, "robotics"))}${manufacturer.country ? ` and country listed as ${escapeHtml(manufacturer.country)}` : ""}. This page connects the company profile to robot models, source-backed database records, and related comparison pages.</p>
        <div class="fr-seo-grid">
          <article><h3>Robotics focus</h3><p>${escapeHtml(safe(manufacturer.focus, "Robotics focus is not fully documented yet."))}</p></article>
          <article><h3>Known models</h3><p>${escapeHtml(safe(manufacturer.models, lineup.map((robot) => robot.name).join(", ") || "No robot models are linked yet."))}</p></article>
          <article><h3>Location</h3><p>${escapeHtml([manufacturer.country, manufacturer.headquarters].filter(Boolean).join(" - ") || "Country and headquarters are not fully documented yet.")}</p></article>
          <article><h3>Source confidence</h3><p>${Number(manufacturer.confidence || 0).toLocaleString()}% confidence with ${Number(manufacturer.sourceCount || 0).toLocaleString()} source records attached where available.</p></article>
        </div>
        <h3>Robot lineup</h3>
        ${internalLinkList(lineup.map((robot) => ({ label: robot.name, url: robotUrl(robot) })))}
        <h3>FAQ</h3>
        ${faqBlock([
          [`What robots does ${manufacturer.name} make?`, `${manufacturer.models || lineup.map((robot) => robot.name).join(", ") || "The linked robot lineup is still being expanded."}`],
          [`Where is ${manufacturer.name} based?`, `${[manufacturer.country, manufacturer.headquarters].filter(Boolean).join(" - ") || "Location data is not fully documented yet."}`],
          [`How should I verify ${manufacturer.name} data?`, `Use the linked robot profiles, manufacturer website, product pages, and source records. Unknown company details should stay unconfirmed until supported by a source.`]
        ])}
      </section>`;
  };
  const comparisonSeoContent = (robots) => {
    if (!robots.length) return "";
    const names = robots.map((robot) => robot.name).join(" vs ");
    return `
      <section class="fr-seo-article fr-card fr-section">
        <p class="fr-eyebrow">Comparison Analysis</p>
        <h2>${escapeHtml(names)} comparison guide</h2>
        <p>This comparison is designed to help buyers, researchers, engineers, and robotics enthusiasts evaluate differences in price, availability, dimensions, payload, runtime, DOF, and maturity. The table is a starting point; each robot profile contains deeper source notes and missing-data warnings.</p>
        <div class="fr-seo-grid">
          <article><h3>Short verdict</h3><p>Choose the robot with the best match for your intended use case, not simply the most familiar brand. Availability and support matter as much as headline specifications.</p></article>
          <article><h3>Key differences</h3><p>${escapeHtml(robots.map((robot) => `${robot.name}: ${compactStatus(robot.status)}, ${compactPrice(robot.price)}`).join("; "))}</p></article>
          <article><h3>Data limitations</h3><p>Several humanoid robot projects publish incomplete or changing data. Treat unknown fields as unknown and verify directly with the manufacturer before buying or citing.</p></article>
          <article><h3>Best next step</h3><p>Open each robot profile to inspect source links, image galleries, videos, and full specification sections before making a decision.</p></article>
        </div>
        <h3>Related robot profiles</h3>
        ${internalLinkList(robots.map((robot) => ({ label: robot.name, url: robotUrl(robot) })))}
      </section>`;
  };
  const toolSeoContent = (data) => `
    <section class="fr-seo-article fr-card fr-section">
      <p class="fr-eyebrow">Robot Tools</p>
      <h2>Robot finder, comparison tools and calculators</h2>
      <p>Firgelli Robots tools are built on the Knowledge Brain, including robot specifications, manufacturer records, availability notes, approved imagery, source links, and research records. The tools are intended for early research, not final procurement without source verification.</p>
      <div class="fr-seo-grid">
        <article><h3>Robot Compare</h3><p>Use the comparison tool to evaluate price, height, payload, runtime, DOF, mobility, and availability side by side.</p></article>
        <article><h3>Robot Finder</h3><p>Use the finder workflow to narrow robots by intended use, environment, budget assumptions, and hardware priorities.</p></article>
        <article><h3>Cost of ownership</h3><p>Future calculator modules can include robot purchase price, service, accessories, batteries, deployment support, and downtime assumptions.</p></article>
        <article><h3>Limitations</h3><p>Unknown price, battery, safety, warranty, and support data should not be guessed. The tools should surface missing data clearly.</p></article>
      </div>
      <h3>Related guides</h3>
      ${internalLinkList([{ label: "Humanoid robot price guide", url: "/pages/knowledge?topic=Price" }, { label: "Robot payload explained", url: "/pages/knowledge?topic=Payload" }, { label: "Robot runtime explained", url: "/pages/knowledge?topic=Runtime" }, { label: "Compare robots", url: "/pages/compare" }])}
    </section>`;
  const researchSeoContent = (data) => `
    <section class="fr-seo-article fr-card fr-section">
      <p class="fr-eyebrow">Research Hub</p>
      <h2>Humanoid robot research, patents, manuals and source references</h2>
      <p>The research hub organizes source material behind robot profiles: official product pages, manuals, papers, patents, videos, and supporting references. The goal is to separate manufacturer claims, third-party coverage, and technical documentation so users can verify what is known.</p>
      <div class="fr-seo-grid">
        <article><h3>Plain-English summary</h3><p>Use this page to move from a robot card to the evidence behind it. Source records help explain where specifications, images, availability notes, and technical claims came from.</p></article>
        <article><h3>Technical summary</h3><p>The database currently tracks ${Number(data.stats.sources || 0).toLocaleString()} source records, ${Number(data.stats.papersPatents || 0).toLocaleString()} papers/patents, and ${Number(data.stats.manualsDocs || 0).toLocaleString()} manuals/docs.</p></article>
        <article><h3>Why it matters</h3><p>Humanoid robotics changes quickly. Source-backed pages are more trustworthy than static lists because they show which details are verified and which still need research.</p></article>
        <article><h3>How to use sources</h3><p>Prioritize official product pages and technical documents for specifications, then use papers, patents, and reputable coverage for context.</p></article>
      </div>
    </section>`;

  async function loadData(root) {
    if (state.data) return state.data;
    const rawUrl = root?.dataset?.dataUrl || document.querySelector("[data-data-url]")?.dataset?.dataUrl;
    const url = new URL(rawUrl, window.location.href);
    if (url.pathname.includes("/fr-robot-data")) {
      url.pathname = url.pathname.replace(/fr-robot-data(?:-[^/]+)?\.json$/, "fr-robot-data-public-20260705.json");
      url.search = "";
      url.searchParams.set("fr_cache", Date.now());
    }
    const response = await fetch(url.toString(), { cache: "no-store" });
    state.data = await response.json();
    return state.data;
  }

  function renderHero(data) {
    const target = document.querySelector("[data-fr-hero-robots]");
    if (!target) return;
    target.innerHTML = data.featuredRobots.slice(0, 4).map((robot) => `
      <a class="fr-hero-robot" href="${robotUrl(robot)}">
        <span class="fr-hero-robot__image">${image(robot)}</span>
        <strong>${escapeHtml(robot.name.replace("Tesla ", ""))}</strong>
      </a>
    `).join("");
  }

  function renderFeaturedTable(data) {
    const table = document.querySelector("[data-fr-featured-table]");
    if (!table) return;
    const robots = data.featuredRobots.slice(0, 10);
    const rows = [
      ["Price (USD)", "price"],
      ["Height", "height"],
      ["Weight", "weight"],
      ["DOF", "dof"],
      ["Payload", "payload"],
      ["Runtime", "runtime"],
      ["Walking Speed", "speed"],
      ["Release Status", "status"]
    ];
    table.innerHTML = `
      <colgroup><col class="fr-compare-label-col">${robots.map(() => `<col class="fr-compare-robot-col">`).join("")}</colgroup>
      <thead><tr><th scope="col"></th>${robots.map((robot) => `<th scope="col"><a class="fr-table-robot" href="${robotUrl(robot)}">${image(robot)}<span>${escapeHtml(robot.name)}</span></a></th>`).join("")}</tr></thead>
      <tbody>${rows.map(([label, key]) => `<tr><td><a href="/pages/knowledge?topic=${encodeURIComponent(label)}">${label}</a></td>${robots.map((robot) => `<td>${escapeHtml(compactComparisonValue(robot, key))}</td>`).join("")}</tr>`).join("")}</tbody>`;
  }

  function bindFeaturedTableScroll() {
    document.querySelectorAll("[data-fr-scroll-table]").forEach((button) => {
      button.addEventListener("click", () => {
        const section = button.closest(".fr-section");
        const wrap = section ? section.querySelector(".fr-table-wrap") : document.querySelector(".fr-table-wrap");
        if (!wrap) return;
        const direction = Number(button.dataset.frScrollTable || 1);
        wrap.scrollBy({ left: direction * Math.round(wrap.clientWidth * 0.82), behavior: "smooth" });
      });
    });
  }

  function renderCategories(data) {
    const target = document.querySelector("[data-fr-categories]");
    if (!target) return;
    target.innerHTML = data.categories.map((category) => `
      <a class="fr-category-card" href="/pages/category?filter=${encodeURIComponent(category.slug)}">
        <span class="fr-category-card__icon">${categoryIcon(category.slug)}</span>
        <strong>${escapeHtml(category.label)}</strong>
        <span>${category.count}+ Robots</span>
      </a>
    `).join("");
  }

  function renderStats(data) {
    const target = document.querySelector("[data-fr-stats]");
    if (!target) return;
    const stats = [
      ["Humanoid Robots", data.stats.humanoidRobots],
      ["Manufacturers", data.stats.manufacturers],
      ["Specifications", data.stats.specifications],
      ["Images", data.stats.images],
      ["Videos", data.stats.videos],
      ["Patents & Papers", data.stats.papersPatents]
    ];
    target.innerHTML = stats.map(([label, value]) => `<div class="fr-stat"><span class="fr-stat__icon">${icon()}</span><div><strong>${Number(value || 0).toLocaleString()}+</strong><span>${escapeHtml(label)}</span></div></div>`).join("");
  }

  function renderLatest(data) {
    const target = document.querySelector("[data-fr-latest]");
    if (!target) return;
    target.innerHTML = data.latestRobots.slice(0, 5).map((robot) => `
      <article class="fr-robot-card">
        <a href="${robotUrl(robot)}">${image(robot)}</a>
        <div>
          <h3><a href="${robotUrl(robot)}">${escapeHtml(robot.name)}</a></h3>
          <dl>
            <div><dt>Manufacturer</dt><dd>${escapeHtml(robot.manufacturer || "Unknown")}</dd></div>
            <div><dt>Price Est.</dt><dd>${escapeHtml(robot.price)}</dd></div>
            <div><dt>Height</dt><dd>${escapeHtml(robot.height || "Unknown")}</dd></div>
          </dl>
          <span class="${badgeClass(robot.status)}">${escapeHtml(robot.status || "Review")}</span>
        </div>
      </article>
    `).join("");
  }

  function renderViewShowcase(data) {
    const target = document.querySelector("[data-fr-view-showcase]");
    if (!target) return;
    const robot = data.robots.find((item) => item.slug === "tesla-optimus" || item.id === "robot_optimus_f2db54a655");
    if (!robot || !Array.isArray(robot.imageViews) || !robot.imageViews.length) {
      target.remove();
      return;
    }
    target.innerHTML = `
      <div class="fr-section__header">
        <div>
          <h2>${escapeHtml(robot.manufacturer)} ${escapeHtml(robot.name)}</h2>
        </div>
        <a href="${robotUrl(robot)}">Open Robot Profile -></a>
      </div>
      ${viewGallery(robot)}
    `;
  }

  function renderTools(data) {
    const target = document.querySelector("[data-fr-tools]");
    if (!target) return;
    target.innerHTML = data.tools.map((tool) => `
      <article class="fr-tool-card">
        <span class="fr-tool-card__icon">${icon()}</span>
        <strong>${escapeHtml(tool.title)}</strong>
        <p>${escapeHtml(tool.description)}</p>
        <a href="${escapeHtml(tool.url)}">${escapeHtml(tool.cta)} -></a>
      </article>
    `).join("");
  }

  function renderManufacturerMarquee(data) {
    const target = document.querySelector("[data-fr-manufacturer-marquee]");
    if (!target) return;
    const manufacturers = [...(data.manufacturers || [])]
      .filter((manufacturer) => manufacturer && manufacturer.name)
      .sort((a, b) => String(a.name).localeCompare(String(b.name)));
    if (!manufacturers.length) {
      target.closest(".fr-manufacturer-marquee")?.remove();
      return;
    }
    const row = [...manufacturers, ...manufacturers];
    target.innerHTML = row.map((manufacturer) => {
      const logo = manufacturer.logo || manufacturer.logoFallback || "";
      return `
        <a class="fr-manufacturer-logo" href="/pages/manufacturer-profile?manufacturer=${encodeURIComponent(manufacturer.slug || "")}" aria-label="${escapeHtml(`Open ${manufacturer.name} manufacturer profile`)}">
          <strong>${escapeHtml(manufacturer.name)}</strong>
          ${logo ? `<img loading="lazy" src="${escapeHtml(logo)}" alt="${escapeHtml(`${manufacturer.name} logo`)}">` : ""}
        </a>`;
    }).join("");
    target.querySelectorAll("img").forEach((img) => {
      img.addEventListener("error", () => {
        img.hidden = true;
      }, { once: true });
    });
  }

  function renderControls(kind, data) {
    const controls = document.querySelector("[data-fr-page-controls]");
    if (!controls) return;
    if (["robots", "compare", "category", "tools", "knowledge", "news", "developers", "marketplace", "community"].includes(kind)) {
      controls.innerHTML = `
        <input type="search" placeholder="Search robots, manufacturers, specs..." data-fr-filter-search>
        <select data-fr-filter-category><option value="">All categories</option>${data.categories.map(c => `<option value="${escapeHtml(c.slug)}">${escapeHtml(c.label)}</option>`).join("")}</select>
        <select data-fr-filter-status><option value="">All availability</option>${[...new Set(data.robots.map(r => r.status).filter(Boolean))].sort().map(s => `<option value="${escapeHtml(s)}">${escapeHtml(s)}</option>`).join("")}</select>
      `;
      const category = new URLSearchParams(location.search).get("filter");
      const query = new URLSearchParams(location.search).get("q") || "";
      const searchInput = controls.querySelector("[data-fr-filter-search]");
      const categorySelect = controls.querySelector("[data-fr-filter-category]");
      if (query && searchInput) searchInput.value = query;
      if (category && categorySelect) categorySelect.value = category;
    }
  }

  const normalizeSearch = (value = "") => String(value || "").toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();

  function filteredRobots(data) {
    const q = normalizeSearch(document.querySelector("[data-fr-filter-search]")?.value || new URLSearchParams(location.search).get("q") || "");
    const category = document.querySelector("[data-fr-filter-category]")?.value || new URLSearchParams(location.search).get("filter") || "";
    const status = document.querySelector("[data-fr-filter-status]")?.value || "";
    return data.robots.filter((robot) => {
      const rawFieldHay = Object.values(robot.rawFields || {}).join(" ");
      const specHay = (robot.specSections || []).flatMap((section) => (section.rows || []).map((row) => `${row.label} ${row.value}`)).join(" ");
      const hay = normalizeSearch(`${robot.id} ${robot.slug} ${robot.name} ${robot.manufacturer} ${robot.summary} ${robot.category} ${robot.useCase} ${rawFieldHay} ${specHay}`);
      if (q && !q.split(" ").every((token) => hay.includes(token))) return false;
      if (status && robot.status !== status) return false;
      if (category && !robot.flags[category] && robot.category !== category) return false;
      return true;
    });
  }

  function renderPageResults(kind, data) {
    const target = document.querySelector("[data-fr-page-results]");
    if (!target) return;
    if (kind === "robot-profile") {
      const slug = new URLSearchParams(location.search).get("robot") || "";
      const robot = data.robots.find(r => robotMatchesSlug(r, slug)) || data.robots[0];
      const specSummary = robot.specSummary || {};
      target.closest(".fr-page-shell")?.classList.add("fr-page-shell--robot-profile");
      const pageEyebrow = document.querySelector(".fr-page-hero .fr-eyebrow");
      const pageHeading = document.querySelector(".fr-page-hero h1");
      const pageCopy = document.querySelector(".fr-page-hero p:not(.fr-eyebrow)");
      const maker = robot.manufacturer || "Unknown manufacturer";
      const publicSummary = robot.summary || `${robot.name} is a ${robot.category || "robot"} from ${maker}. This page brings together specifications, availability, images, videos, and source links in one public robot profile.`;
      setRobotSeo(robot);
      if (pageEyebrow) pageEyebrow.textContent = `${maker} robot profile`;
      if (pageHeading) pageHeading.textContent = robot.name;
      if (pageCopy) pageCopy.textContent = publicSummary;
      const standardViews = pickMediaSet(robot, [
        ["Front view", ["front", "portrait"]],
        ["Side view", ["side"]],
        ["Rear view", ["rear", "back"]],
        ["Head and torso", ["head", "torso"]],
        ["Arm detail", ["arm"]],
        ["Leg detail", ["leg", "feet", "foot"]],
        ["Arm and leg detail", ["arm leg"]]
      ], 7).filter((item) => String(item.image || "") !== String(robot.image || ""));
      const mediaItems = uniqueMedia(approvedMedia(robot), 18);
      const standardImageKeys = new Set(standardViews.map((item) => String(item.image || "")));
      if (robot.image) standardImageKeys.add(String(robot.image));
      const supplementalMediaItems = mediaItems.filter((item) => !standardImageKeys.has(String(item.image || "")));
      const quickSpecs = [
        ["Price", robot.price],
        ["Availability", robot.status],
        ["Height", robot.height],
        ["Weight", robot.weight],
        ["Payload", robot.payload],
        ["Runtime", robot.runtime],
        ["DOF", robot.dof],
        ["Speed", robot.speed],
        ["Battery", specLookup(robot, ["Battery Capacity"])],
        ["Actuators", specLookup(robot, ["Actuator Count"])],
      ];
      const videoCount = Array.isArray(robot.videos) ? robot.videos.length : 0;
      const documentedSpecs = Number(specSummary.Known || 0) + Number(specSummary.Calculated || 0) + Number(specSummary.Estimated || 0);
      const sourceTotal = Number((robot.sources || []).length + (robot.manuals || []).length + (robot.papers || []).length + (robot.communityMentions || []).length);
      const bestFor = listFromText(rawField(robot, "best_for") || robot.useCase || robot.targetMarket).join(", ") || `${robot.category || "robotics"} research, comparison, and buyer evaluation`;
      const caveats = listFromText(rawField(robot, "known_limitations") || rawField(robot, "known_issues") || rawField(robot, "not_best_for")).join(", ") || "Public specifications can change as the manufacturer releases new details.";
      const competitors = listFromText(rawField(robot, "competitors") || rawField(robot, "similar_robots")).join(", ") || data.featuredRobots.filter((item) => item.slug !== robot.slug).slice(0, 4).map((item) => item.name).join(", ");
      const productUrl = robot.productPage || robot.source || rawField(robot, "product_page_url") || rawField(robot, "robot_url");
      const metrics = [
        ["Documented specs", `${documentedSpecs.toLocaleString()} fields`],
        ["Reference links", `${sourceTotal.toLocaleString()} sources`],
        ["Images", `${mediaItems.length.toLocaleString()} views`],
        ["Videos", `${videoCount.toLocaleString()} clips`],
        ["Data confidence", `${Number(robot.confidence || 0).toLocaleString()}%`]
      ];
      const hasDisplayValue = (value) => {
        const text = String(value ?? "").replace(/\s+/g, " ").trim();
        return text && !/^(unknown|n\/a|na|none|null|not available|not publicly listed)$/i.test(text);
      };
      const cleanSentence = (value) => String(value || "").replace(/\s+/g, " ").trim().replace(/[.;,\s]+$/, "");
      const sentence = (value, fallback = "") => cleanSentence(value) || fallback;
      const compactList = (items, fallback = "") => {
        const values = Array.isArray(items) ? items : listFromText(items);
        return values.map(cleanSentence).filter(Boolean).slice(0, 6).join(", ") || fallback;
      };
      const plural = (count, singular, pluralWord) => `${Number(count || 0).toLocaleString()} ${Number(count || 0) === 1 ? singular : pluralWord || `${singular}s`}`;
      const sourcePhrase = sourceTotal ? plural(sourceTotal, "reference record") : "source-backed KB records";
      const specPhrase = documentedSpecs ? plural(documentedSpecs, "documented specification field") : "the currently available public specification fields";
      const imagePhrase = mediaItems.length ? plural(mediaItems.length, "approved image/media view") : "image coverage that is still being expanded";
      const videoPhrase = videoCount ? plural(videoCount, "video reference") : "video coverage that is still being expanded";
      const makerPhrase = maker && maker !== "Unknown" ? maker : "its listed manufacturer";
      const categoryPhrase = robot.category ? `${robot.category} robot` : "robotics platform";
      const targetMarkets = compactList(robot.targetMarket || robot.useCase || rawField(robot, "target_market") || rawField(robot, "use_cases"), "robot buyers, engineers, researchers, and comparison shoppers");
      const specHighlights = quickSpecs
        .filter(([, value]) => hasDisplayValue(value))
        .slice(0, 6)
        .map(([label, value]) => `${label}: ${String(value).replace(/\s+/g, " ").trim()}`)
        .join("; ");
      const statusText = sentence(robot.status, "availability not publicly listed");
      const priceText = sentence(robot.price, "not publicly listed");
      const caveatText = sentence(caveats, "Public specifications can change as the manufacturer releases new details");
      const competitorText = competitors || "other leading humanoid, service, research, and enterprise robot platforms";
      const overviewText = `${robot.name} is a ${categoryPhrase} from ${makerPhrase}. ${publicSummary} Our read is that this robot is worth looking at for ${targetMarkets}, but it should be judged by what is actually published today: size, payload, runtime, mobility, software access, safety claims, and whether real customers can buy or deploy it.`;
      const availabilityText = `${robot.name} is currently listed as ${statusText}. Pricing is ${priceText}. That buying status matters: a preorder, pilot program, enterprise quote, research platform, prototype, or discontinued model all mean very different things for buyers. Before treating it like a finished product, check delivery timing, support, warranty terms, subscription costs, and what capabilities are available at launch.`;
      const bestFitText = `Based on its published specs and positioning, ${robot.name} looks most relevant for ${targetMarkets}. The strongest use cases will be the ones where its height, weight, payload, runtime, hands or grippers, mobility, and software ecosystem line up with the work being asked of it. It should be evaluated as a practical robot, not just as a headline or demo video.`;
      const watchText = `${caveatText}. The main things to verify are release timing, purchase availability, safety claims, autonomy level, SDK or ROS access, payload and runtime tradeoffs, battery details, sensor package, hand design, actuator details, walking speed, and whether the manufacturer has published stable measurements that can be compared fairly against other robots.`;
      const compareText = `A useful comparison set for ${robot.name} includes ${competitorText}. Compare them on price, availability, height, weight, payload, runtime, degrees of freedom, walking speed, end effectors, software access, service model, manufacturer maturity, and how much real-world deployment evidence exists.`;
      const coverageText = `${robot.name} has ${specPhrase} available for review. Specification highlights${specHighlights ? ` include ${specHighlights}` : " are still being filled in as more public details become available"}. The most important takeaway is not a single number, but whether the published capabilities match the job: lifting, walking, sensing, manipulating objects, operating safely around people, and being supported after deployment.`;
      const reviewNotes = [
        ["What it is", overviewText],
        ["Availability and pricing", availabilityText],
        ["Best fit", bestFitText],
        ["What to watch", watchText],
        ["Comparable robots", compareText],
        ["Specs that matter", coverageText]
      ];
      const mediaTabImages = mediaGallery(supplementalMediaItems, robot) || `<p class="fr-muted">Additional robot images will appear here as more angles are added.</p>`;
      target.innerHTML = `
        <div class="fr-robot-profile">
          <section class="fr-robot-hero">
            <div class="fr-robot-hero__copy">
              <div class="fr-robot-pill-row">
                <span class="fr-robot-pill">${escapeHtml(maker)}</span>
                <span class="fr-robot-pill">${escapeHtml(compactStatus(robot.status))}</span>
                <span class="fr-robot-pill">${escapeHtml(robot.category || "Robot")}</span>
              </div>
              <h2>${escapeHtml(robot.name)} robot review and specifications</h2>
              <p>${escapeHtml(publicSummary)}</p>
              <div class="fr-profile__actions">
                <a class="fr-button" href="/pages/compare?add=${encodeURIComponent(robot.slug)}">Compare ${escapeHtml(robot.name)}</a>
                ${productUrl ? `<a class="fr-button fr-button--secondary" href="${escapeHtml(productUrl)}">Official page</a>` : ""}
              </div>
            </div>
            <div class="fr-robot-hero__image">${image(robot, `${robot.name} robot`)}</div>
            <aside class="fr-robot-facts" aria-label="${escapeHtml(robot.name)} key facts">
              <p class="fr-eyebrow">Key facts</p>
              <h2>At a glance</h2>
              <div class="fr-robot-fact-grid">
                ${quickSpecs.map(([k, v]) => `<div class="fr-robot-fact"><span>${escapeHtml(k)}</span><strong>${escapeHtml(shortValue(v))}</strong></div>`).join("")}
              </div>
            </aside>
          </section>

          <section class="fr-robot-panel">
            <div class="fr-robot-section-header">
              <div>
                <p class="fr-eyebrow">Images and videos</p>
                <h2>${escapeHtml(robot.name)} photo gallery and movement media</h2>
                <p>Standardized views make it easier to compare body shape, proportions, end effectors, and visible hardware across robots.</p>
              </div>
              <span>${Number(mediaItems.length).toLocaleString()} images / ${Number(videoCount).toLocaleString()} videos</span>
            </div>
            ${mediaTileGrid(standardViews, robot, "fr-angle-grid--standard")}
            <div class="fr-tabs fr-robot-media-tabs" data-fr-tabs>
              <div class="fr-tab-list" role="tablist" aria-label="${escapeHtml(robot.name)} media">
                <button type="button" class="is-active" data-fr-tab-button="gallery">Additional images</button>
                <button type="button" data-fr-tab-button="videos">Videos</button>
              </div>
              <div class="fr-tab-panel is-active" data-fr-tab-panel="gallery">${mediaTabImages}</div>
              <div class="fr-tab-panel" data-fr-tab-panel="videos" hidden>${videoIframes(robot)}</div>
            </div>
          </section>

          <section class="fr-robot-panel">
            <div class="fr-robot-section-header">
              <div>
                <p class="fr-eyebrow">Robot review profile</p>
                <h2>Our review, buying status, and research notes</h2>
              </div>
            </div>
            <div class="fr-robot-review-grid">
              ${reviewNotes.map(([label, text]) => `<article class="fr-robot-note"><strong>${escapeHtml(label)}</strong><span>${escapeHtml(text)}</span></article>`).join("")}
            </div>
          </section>

          <section class="fr-robot-panel">
            <div class="fr-robot-section-header">
              <div>
                <p class="fr-eyebrow">Profile coverage</p>
                <h2>Documented facts and source coverage</h2>
                <p>These counters summarize how much public robot information is currently connected to this profile.</p>
              </div>
            </div>
            <div class="fr-robot-metrics">
              ${metrics.map(([label, value]) => `<div class="fr-robot-metric"><span>${escapeHtml(label)}</span><strong>${escapeHtml(value)}</strong></div>`).join("")}
            </div>
          </section>

          ${robotSeoArticle(robot, data)}

          <section class="fr-robot-panel">
            <div class="fr-robot-section-header">
              <div>
                <p class="fr-eyebrow">Specifications</p>
                <h2>Full ${escapeHtml(robot.name)} specification sheet</h2>
                <p>Technical fields are separated by category so buyers, researchers, and search engines can compare robots field by field.</p>
              </div>
              <span>${Number(specSummary.Total || 0).toLocaleString()} spec fields</span>
            </div>
            ${renderSpecSections(robot)}
          </section>

          <section class="fr-robot-panel">
            <div class="fr-robot-section-header">
              <div>
                <p class="fr-eyebrow">Sources</p>
                <h2>Verified ${escapeHtml(robot.name)} sources and further reading</h2>
                <p>Use these links to verify manufacturer claims, inspect technical documentation, and continue deeper robot research.</p>
              </div>
            </div>
            ${robotSourcesPanel(robot)}
          </section>
        </div>`;
      bindTabs(target);
      return;
    }
    if (kind === "manufacturer-profile" || kind === "manufacturers") {
      const slug = new URLSearchParams(location.search).get("manufacturer");
      const manufacturers = slug ? data.manufacturers.filter(m => m.slug === slug) : data.manufacturers;
      const overview = slug && manufacturers[0] ? manufacturerSeoContent(manufacturers[0], data.robots) : `
        <section class="fr-seo-article fr-card fr-section">
          <p class="fr-eyebrow">Manufacturer Guide</p>
          <h2>Robot manufacturers tracked by Firgelli Robots</h2>
          <p>This manufacturer database connects companies to robot lineups, countries, public websites, focus areas, and source-backed robot profiles. Use it to move from a robot model to the company behind it.</p>
        </section>`;
      target.innerHTML = `${overview}<div class="fr-results-grid">${manufacturers.map(m => `<article class="fr-tool-card"><span class="fr-tool-card__icon">${icon()}</span><strong>${escapeHtml(m.name)}</strong><p>${escapeHtml([m.country, m.focus, m.models].filter(Boolean).join(" - ") || "Manufacturer profile queued for enrichment.")}</p><a href="/pages/manufacturer-profile?manufacturer=${encodeURIComponent(m.slug)}">View Manufacturer -></a></article>`).join("")}</div>`;
      return;
    }
    if (kind === "research") {
      const docs = [...data.research.papersPatents, ...data.research.manualsDocs, ...data.research.sources].slice(0, 80);
      target.innerHTML = `${researchSeoContent(data)}<div class="fr-results-grid">${docs.map(doc => `<article class="fr-tool-card"><span class="fr-tool-card__icon">${icon()}</span><strong>${escapeHtml(doc.title || doc.source_title || doc.document_type || "Research source")}</strong><p>${escapeHtml(doc.document_type || doc.source_type || doc.publisher || "Source-backed research item")}</p><a href="${escapeHtml(doc.url || doc.source_url)}">Open Source -></a></article>`).join("")}</div>`;
      return;
    }
    if (kind === "knowledge") {
      const term = new URLSearchParams(location.search).get("topic") || "";
      const knowledgeCards = [
        ["Price", "Estimated or verified robot purchase price, lease status, or quote requirement."],
        ["Height", "Physical robot height from manufacturer data or trusted source review."],
        ["Weight", "Robot mass including body, battery, and standard configuration where known."],
        ["DOF", "Degrees of freedom: the number of independently controlled motion axes."],
        ["Payload", "Rated carry or manipulation capacity, separated from body weight."],
        ["Runtime", "Expected battery operating time under stated workload."],
        ["Release Status", "Commercial availability, pilot status, prototype status, or announcement state."]
      ];
      const docs = [...data.research.sources, ...data.research.papersPatents].slice(0, 24);
      target.innerHTML = `
        <section class="fr-seo-article fr-card fr-section">
          <p class="fr-eyebrow">Specification Guide</p>
          <h2>${escapeHtml(term || "Robot specifications")} explained</h2>
          <p>Specification pages explain what each robot attribute means, why it matters, how it is measured, and how to compare robots without over-trusting incomplete manufacturer claims.</p>
          <div class="fr-seo-grid">
            <article><h3>Why it matters</h3><p>Specs like DOF, payload, runtime, price, sensors, LiDAR, SDK support, ROS support, and walking speed help separate practical capability from promotional claims.</p></article>
            <article><h3>How to compare</h3><p>Use the same field across multiple robot profiles, then inspect source status and missing-data warnings. A known lower value is often more useful than an unknown or unsupported claim.</p></article>
            <article><h3>Common misunderstanding</h3><p>One number rarely describes a whole robot. Runtime depends on task, payload depends on pose and safety margin, and price depends on configuration and support.</p></article>
            <article><h3>Related tool</h3><p>Use the robot comparison page to view the same specification across multiple robots side by side.</p></article>
          </div>
        </section>
        <div class="fr-results-grid">
          ${knowledgeCards.filter(([label]) => !term || label.toLowerCase().includes(term.toLowerCase())).map(([label, text]) => `<article class="fr-tool-card"><span class="fr-tool-card__icon">${icon()}</span><strong>${escapeHtml(label)}</strong><p>${escapeHtml(text)}</p><a href="/pages/robots">Browse records -></a></article>`).join("")}
        </div>
        <div class="fr-card fr-section">
          <p class="fr-eyebrow">Trusted Source Feed</p>
          <h2>Latest knowledge-brain sources</h2>
          <div class="fr-results-grid">${docs.map(doc => `<article class="fr-tool-card"><strong>${escapeHtml(doc.source_title || doc.title || "Source record")}</strong><p>${escapeHtml(doc.source_type || doc.document_type || doc.publisher || "Knowledge source")}</p>${doc.url || doc.source_url ? `<a href="${escapeHtml(doc.url || doc.source_url)}">Open source -></a>` : ""}</article>`).join("")}</div>
        </div>`;
      return;
    }
    if (kind === "news") {
      const latest = data.latestRobots.slice(0, 10);
      const sources = data.research.sources.slice(0, 18);
      target.innerHTML = `
        <div class="fr-results-grid">${latest.map(robot => `<article class="fr-robot-card"><a href="${robotUrl(robot)}">${image(robot)}</a><div><h3><a href="${robotUrl(robot)}">${escapeHtml(robot.name)}</a></h3><dl><div><dt>Maker</dt><dd>${escapeHtml(robot.manufacturer || "Unknown")}</dd></div><div><dt>Status</dt><dd>${escapeHtml(robot.status || "Review")}</dd></div></dl><span class="${badgeClass(robot.status)}">${escapeHtml(robot.category)}</span></div></article>`).join("")}</div>
        <div class="fr-card fr-section">
          <p class="fr-eyebrow">Source-backed updates</p>
          <h2>Recent source records</h2>
          <div class="fr-results-grid">${sources.map(doc => `<article class="fr-tool-card"><strong>${escapeHtml(doc.source_title || "Source update")}</strong><p>${escapeHtml(doc.source_domain || doc.source_type || "Knowledge source")}</p>${doc.url ? `<a href="${escapeHtml(doc.url)}">Open source -></a>` : ""}</article>`).join("")}</div>
        </div>`;
      return;
    }
    if (kind === "tools") {
      target.innerHTML = `${toolSeoContent(data)}<div id="robot-finder" class="fr-results-grid">${data.tools.map(tool => `<article class="fr-tool-card"><span class="fr-tool-card__icon">${icon()}</span><strong>${escapeHtml(tool.title)}</strong><p>${escapeHtml(tool.description)}</p><a href="${escapeHtml(tool.url)}">${escapeHtml(tool.cta)} -></a></article>`).join("")}</div>`;
      return;
    }
    if (kind === "developers") {
      const developerRobots = data.robots.filter(robot => String(robot.summary || robot.useCase || robot.category).toLowerCase().includes("research") || robot.flags.research).slice(0, 40);
      target.innerHTML = `<div class="fr-results-grid">${developerRobots.map(robot => `<article class="fr-robot-card"><a href="${robotUrl(robot)}">${image(robot)}</a><div><h3><a href="${robotUrl(robot)}">${escapeHtml(robot.name)}</a></h3><dl><div><dt>Maker</dt><dd>${escapeHtml(robot.manufacturer || "Unknown")}</dd></div><div><dt>Use</dt><dd>${escapeHtml(robot.useCase || robot.category || "Research platform")}</dd></div></dl><span class="${badgeClass(robot.status)}">${escapeHtml(robot.status || "Review")}</span></div></article>`).join("")}</div>`;
      return;
    }
    if (kind === "marketplace") {
      const marketplaceRobots = data.robots.filter(robot => robot.flags.consumer || robot.flags.enterprise || robot.flags.industrial || robot.flags.humanoid).slice(0, 40);
      target.innerHTML = `<div class="fr-card fr-section"><p class="fr-eyebrow">Marketplace Foundation</p><h2>Robots ready for future commerce mapping</h2><p>These public robot profiles can later connect to accessories, skills, compatible parts, service plans, and quote flows as the marketplace grows.</p></div><div class="fr-results-grid">${marketplaceRobots.map(robot => `<article class="fr-robot-card"><a href="${robotUrl(robot)}">${image(robot)}</a><div><h3><a href="${robotUrl(robot)}">${escapeHtml(robot.name)}</a></h3><dl><div><dt>Maker</dt><dd>${escapeHtml(robot.manufacturer || "Unknown")}</dd></div><div><dt>Price</dt><dd>${escapeHtml(robot.price || "Quote")}</dd></div></dl><span class="${badgeClass(robot.status)}">${escapeHtml(robot.status || "Review")}</span></div></article>`).join("")}</div>`;
      return;
    }
    if (kind === "community") {
      const mentions = (data.community || []).slice(0, 80);
      target.innerHTML = `<div class="fr-results-grid">${mentions.map(item => `<article class="fr-tool-card"><span class="fr-tool-card__icon">${icon()}</span><strong>${escapeHtml(item.title || "Community review item")}</strong><p>${escapeHtml(item.notes || item.claim_summary || item.mention_type || "Queued for manual community review.")}</p>${item.url ? `<a href="${escapeHtml(item.url)}">Open mention -></a>` : `<a href="/pages/robots">Open database -></a>`}</article>`).join("")}</div>`;
      return;
    }
    if (kind === "about" || kind === "editorial-policy" || kind === "contact") {
      const body = {
        "about": ["A database-first robotics intelligence platform", `Firgelli Robots is organized around ${data.stats.robots} robot records, ${data.stats.manufacturers} manufacturers, ${data.stats.sources} source records, and ${data.stats.papersPatents} papers/patents for robot buyers, researchers, and builders.`],
        "editorial-policy": ["Editorial and source policy", "Robot specifications, manufacturer claims, images, videos, patents, papers, and community notes are separated by source type. Unverified fields stay marked as unknown until reviewed."],
        "contact": ["Contact Firgelli Robots", "Use this development page as the future intake point for data corrections, manufacturer submissions, marketplace partnerships, and robotics research requests."]
      }[kind];
      target.innerHTML = `<div class="fr-card fr-section"><p class="fr-eyebrow">${escapeHtml(body[0])}</p><h2>${escapeHtml(body[0])}</h2><p>${escapeHtml(body[1])}</p><p><a class="fr-button" href="/pages/robots">Explore Database</a> <a class="fr-button fr-button--secondary" href="/pages/research">Review Sources</a></p></div>`;
      return;
    }
    const robots = filteredRobots(data).slice(0, kind === "compare" ? 4 : 60);
    if (kind === "compare") {
      const rows = [["Price", "price"], ["Height", "height"], ["Weight", "weight"], ["DOF", "dof"], ["Payload", "payload"], ["Runtime", "runtime"], ["Movement", "movement"], ["Status", "status"]];
      const addSlug = new URLSearchParams(location.search).get("add");
      const compareRobots = addSlug ? [data.robots.find(r => r.slug === addSlug), ...robots.filter(r => r.slug !== addSlug)].filter(Boolean).slice(0, 4) : robots;
      target.innerHTML = `<div class="fr-table-wrap"><table class="fr-compare-table"><thead><tr><th></th>${compareRobots.map(r => `<th>${image(r)}<br>${escapeHtml(r.name)}</th>`).join("")}</tr></thead><tbody>${rows.map(([label, key]) => `<tr><td>${label}</td>${compareRobots.map(r => `<td>${escapeHtml(r[key] || "Unknown")}</td>`).join("")}</tr>`).join("")}</tbody></table></div>${comparisonSeoContent(compareRobots)}`;
    } else {
      const seoLead = kind === "category" ? categorySeoContent(kind, data, robots) : "";
      target.innerHTML = `${seoLead}<div class="fr-results-grid">${robots.map(robot => `<article class="fr-robot-card"><a href="${robotUrl(robot)}">${image(robot)}</a><div><h3><a href="${robotUrl(robot)}">${escapeHtml(robot.name)}</a></h3><dl><div><dt>Maker</dt><dd>${escapeHtml(robot.manufacturer || "Unknown")}</dd></div><div><dt>Status</dt><dd>${escapeHtml(robot.status || "Review")}</dd></div><div><dt>Height</dt><dd>${escapeHtml(robot.height || "Unknown")}</dd></div></dl><span class="${badgeClass(robot.status)}">${escapeHtml(robot.category)}</span></div></article>`).join("")}</div>`;
    }
  }

  function bindPageFilters(kind, data) {
    document.querySelectorAll("[data-fr-filter-search], [data-fr-filter-category], [data-fr-filter-status]").forEach((control) => {
      control.addEventListener("input", () => renderPageResults(kind, data));
      control.addEventListener("change", () => renderPageResults(kind, data));
    });
  }

  async function initHome(root) {
    assetBase = root.dataset.assetBase || assetBase;
    const data = await loadData(root);
    renderHero(data);
    renderFeaturedTable(data);
    bindFeaturedTableScroll();
    renderCategories(data);
    renderStats(data);
    renderLatest(data);
    renderViewShowcase(data);
    renderTools(data);
    renderManufacturerMarquee(data);
  }

  async function initPage(root) {
    assetBase = root.dataset.assetBase || assetBase;
    const data = await loadData(root);
    const kind = resolvePageKind(root);
    applyPageMeta(root, kind);
    renderControls(kind, data);
    renderPageResults(kind, data);
    bindPageFilters(kind, data);
  }

  function bindNav() {
    const button = document.querySelector("[data-fr-menu]");
    const nav = document.querySelector("[data-fr-mobile-nav]");
    if (!button || !nav) return;
    button.addEventListener("click", () => {
      const open = nav.classList.toggle("is-open");
      button.setAttribute("aria-expanded", String(open));
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    bindNav();
    document.querySelectorAll("[data-fr-home]").forEach(initHome);
    document.querySelectorAll("[data-fr-page-kind]").forEach(initPage);
  });
})();
